import { inject, Injectable } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LazyLoadingService {
  router = inject(Router);

  private _isLoadingSubject = new Subject<boolean>();
  public $isLoading = this._isLoadingSubject.asObservable();
  private _isLoading = false;

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });
  }

  public set isLoading(newValue: boolean) {
    this._isLoading = newValue;
    this._isLoadingSubject.next(newValue);
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }
}
